import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from '@squiz/xaccel-prop-types';
import { generateClasses } from '@squiz/xaccel-utility-functions';
import AssistedInputContext from '../AssistedInputContext';
import useItemGenerator from './useItemGenerator';
import styles from '../../css/global.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssistedInputSourceFunnelback(_ref) {
  let {
    id,
    source,
    debounce,
    minWord,
    heading,
    generateItem,
    className,
    onSubmit
  } = _ref;
  const existingRequest = useRef();
  const {
    inputValue,
    assistActive,
    isFetching,
    setIsFetching
  } = useContext(AssistedInputContext);

  // Uses this item generator functionality to encapsulate a bit of reusable custom context processing
  const {
    generatedItems,
    setItems
  } = useItemGenerator({
    id,
    generateItem,
    inputValue,
    onSubmit
  });
  useEffect(() => {
    // Debounce need to be suppl
    const delayDebounceFn = setTimeout(async () => {
      // If a current request is happening, cancel it
      if (existingRequest.current) {
        existingRequest.current.abort();
      }
      if (inputValue && inputValue.length >= minWord) {
        const params = Object.keys(source.params || {}).map(key => {
          return `${key}=${source.params[key]}&`;
        }).join('');
        const url = `${source.url}?${params}partial_query=${inputValue}`;

        // Store the existing request in case we need to abort it
        const controller = new AbortController();
        existingRequest.current = controller;
        setIsFetching(true);
        setItems([]);
        fetch(url, {
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(response => response.json()).then(response => {
          // Close the existing request
          existingRequest.current = undefined;
          setItems(response);
          setIsFetching(false);
        }).catch(err => {
          // AbortError is normal if we cancel the request due to more texting being typed
          if (err.name !== 'AbortError') {
            throw err;
          }
          setIsFetching(false);
        });
      } else if (generatedItems?.length > 0) {
        // Only update if it wasn't already empty
        setItems([]);
        setIsFetching(false);
      }
    }, debounce);
    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [inputValue]);
  if (generatedItems?.length === 0) {
    return '';
  }
  return /*#__PURE__*/_jsxs("div", {
    role: "rowgroup",
    className: generateClasses({
      block: 'assisted-input-source',
      modifiers: {
        visible: inputValue !== '' && assistActive && !isFetching
      },
      override: className
    }, styles),
    children: [heading !== '' && /*#__PURE__*/_jsx("h2", {
      className: generateClasses({
        block: 'assisted-input-source',
        element: 'heading',
        override: className
      }, styles),
      children: heading
    }), generatedItems]
  });
}
AssistedInputSourceFunnelback.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.string,
  source: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.object
  }).isRequired,
  debounce: PropTypes.number,
  minWord: PropTypes.number,
  generateItem: PropTypes.func.isRequired,
  className: PropTypes.classNameOverride
};
AssistedInputSourceFunnelback.defaultProps = {
  heading: '',
  debounce: 500,
  minWord: 3,
  className: undefined
};
export default AssistedInputSourceFunnelback;